module.exports = __webpack_public_path__ + "static/media/Janakantha.0feaa064.png";